<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <form [formGroup]="packageTypeForm">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Package type</mat-label>
        <input required formControlName="type" type="text" matInput placeholder="Type">
        @if (packageTypeForm.get('type')?.invalid) {
          <mat-error>
            Package type is invalid
          </mat-error>
        }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Code</mat-label>
        <input required formControlName="code" type="text" matInput placeholder="Code">
        @if (packageTypeForm.get('code')?.invalid) {
          <mat-error>
            Code is invalid
          </mat-error>
        }
      </mat-form-field>
    </p>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button  color="primary" (click)="createPackageType()">Create</button>
</div>
